export default class InitialPage {
    constructor($root, mainController) {
        this.$nextPageButton = $root.querySelector('.quiz-initial_start');
        this.$tip = $root.querySelector('.quiz-initial_tip');
        this.mainController = mainController;
        this.isInitialized = false;
    }

    get isFinished() {
        const storageData = this.mainController.storage.getLocalStorage();
        return storageData && storageData['special-event-quiz'] && storageData['special-event-quiz'].result;
    }

    init(switchPage) {
        const onStartButtonClicked = e => {
            switchPage('next');
        };

        if (!this.isInitialized && !this.isFinished) {
            this.$nextPageButton.addEventListener('click', onStartButtonClicked);

            this.isInitialized = true;
        } else if (this.isFinished) {
            this.$nextPageButton.removeEventListener('click', onStartButtonClicked);
            this.$nextPageButton.setAttribute('disabled', 'disabled');
            this.$tip.classList.remove('-hidden');
        }
    }
}